<template>
  <div>
    <b-card>
      <h4>
          {{$t("Labels.UserInformation")}}
      </h4>
      <b-form
        class=""
        @submit.prevent
      >
      <validation-observer ref="userValidation">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Nombre(s)" label-for="name">
            <validation-provider #default="{ errors }" name="name" rules="required">
              <b-form-input id="name" v-model="user.firstName" :state="errors.length > 0 ? false:null" name="name" placeholder="Nombre(s)"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Apellido(s)" label-for="lastName">
            <validation-provider #default="{ errors }" name="lastName" rules="required">
              <b-form-input id="lastName" v-model="user.lastName" :state="errors.length > 0 ? false:null" name="lastName" placeholder="Apellido(s)"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Teléfono" label-for="phone">
            <validation-provider #default="{ errors }" name="phone" rules="required|digits:10">
              <b-form-input id="phone" v-model="user.phone" :state="errors.length > 0 ? false:null" name="phone" :options="options.phoneMask" placeholder="Teléfono"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Correo Electrónico" label-for="email">
            <validation-provider #default="{ errors }" name="email" rules="required|email">
              <b-form-input id="email" v-model="user.email" :state="errors.length > 0 ? false:null" name="email" placeholder="Correo Electrónico" disabled/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Tipo de usuario" label-for="userType">
            <validation-provider #default="{ errors }" name="tipo de usuario" rules="required">
              <v-select input-id="userType" :options="userType" :state="errors.length > 0 ? false:null" :clearable="false" v-model="selectedType" placeholder="Tipo de usuario"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="RPE" label-for="rpe">
            <validation-provider #default="{ errors }" name="RPE" rules="required">
              <b-form-input id="rpe" v-model="user.rpe" :state="errors.length > 0 ? false:null"  name="rpe" placeholder="RPE"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="selectedType.value !== 'C'">
        <b-col cols="12" md="6" class="mb-md-0 mb-2">
          <b-form-group label="Zona" label-for="cfeZone" >
            <v-select input-id="cfeZone" :options="listZones" v-model="selectedZone" label="name" multiple>
              <template #no-options>
                No tienes zonas disponibles en esta división. Registra al menos una para continuar.
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>

      <h4>
          Modificar NIP
      </h4>

      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="NIP" label-for="NIP">
            <b-form-input id="NIP" v-model="NIP" autocomplete="off" name="NIP" placeholder="NIP" maxlength="4" type="password"/>
          </b-form-group>
        </b-col>
      </b-row>

      <h4>
          {{$t("Labels.ChangePassword")}}
      </h4>

      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Contraseña" label-for="password">
            <validation-provider #default="{ errors }" name="password" rules="password">
              <b-form-input id="password" v-model="pass" :state="errors.length > 0 ? false:null" name="password" placeholder="Contraseña" type="password"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Confirmar contraseña" label-for="confirmPassword">
            <validation-provider #default="{ errors }" name="confirmPassword" rules="confirmed:password">
              <b-form-input id="confirmPassword" v-model="confirmPassword" :state="errors.length > 0 ? false:null" name="confirmPassword" placeholder="Confirmar contraseña" type="password"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6" offset-md="6" class="d-flex justify-content-end">
          <b-col cols="6">
            <b-button type="submit" variant="primarySpore" block @click="validationForm" class="mt-2">{{$t("Labels.Save")}}</b-button>
            </b-col>
          &nbsp;
          <b-col cols="6">
            <b-button type="reset" block variant="danger" @click="cancel()" class="mt-2" >{{$t("Labels.Cancel")}}</b-button>
          </b-col>
        </b-col>
      </b-row>
      </validation-observer>
      </b-form>
    </b-card>
  </div>
</template>
<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BFormInput,
  BForm,
  BButton
} from 'bootstrap-vue'
import { required } from '@validations'
import request from '@/libs/request/index'
import { empty } from '@/libs/tools/helpers'
import vSelect from 'vue-select'

/* eslint-disable quotes */
import { hashString } from "@/libs/session/index"

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    BForm,
    vSelect,
    BButton,
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      listZones: [],
      selectedZone: [],
      guardarZone: [],
      user: {},
      uuid: this.$route.params.uuid,
      required,
      userType: [
        { value: 'C', label: 'Administrador CFE' },
        { value: 'S', label: 'Supervisor' },
        { value: 'I', label: 'Instalador' }
      ],
      options: {
        phoneMask: {
          blocks: [3, 3, 4],
          uppercase: true
        }
      },
      selectedType: {},
      validated: 0,
      pass: '',
      NIP: '',
      confirmPassword: ''
    }
  },
  methods: {
    cancel () {
      this.user = {}
      this.$router.push('/users')
    },
    async getZones () {
      const params = {
        url: '/zones',
        method: 'GET',
        params: { divisionUuid: this.$store.state.session.AppActiveUser().division.uuid }
      }
      const { data } = await request(params)
      this.listZones = data
    },
    async save () {
      if (this.selectedType.value === undefined) {
        this.$swal({
          title: 'Favor de ingresar el tipo de usuario',
          text: '',
          timer: 5000,
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-warning'
          },
          buttonsStyling: false
        })
      } else if (this.selectedType.value !== 'C' && this.selectedZone.length === 0) {
        this.$swal({
          title: 'Favor de ingresar la zona',
          text: '',
          timer: 5000,
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-warning'
          },
          buttonsStyling: false
        })
      } else {
        this.guardarZone = []
        this.selectedZone.forEach(element => {
          this.guardarZone.push(element.uuid)
        })

        const params = {
          url: `users/${this.uuid}`,
          method: 'PUT',
          params: {
            email: this.user.email,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            phone: this.user.phone,
            rpe: this.user.rpe
          }
        }
        if (this.pass) {
          Object.assign(params.params, {
            password: this.pass,
            repassword: this.confirmPassword
          })
        }
        if (this.NIP) {
          Object.assign(params.params, {
            nip: hashString(this.NIP)
          })
        }
        if (this.selectedType.value) {
          Object.assign(params.params, {
            type: this.selectedType.value
          })
        }
        if (this.selectedType.value !== 'C') {
          Object.assign(params.params, {
            zones: this.guardarZone
          })
        }
        await request(params).then(response => {
          this.$refs.userValidation.reset()
          this.user = {}
          this.$router.push('/users')
        }).catch(err => {
          const errMsg = err?.response?.data?.error || err?.response?.data?.msg
          if (errMsg) {
            this.$swal({
              title: 'Error',
              text: errMsg,
              timer: 5000,
              icon: 'warning',
              customClass: {
                confirmButton: 'btn btn-warning'
              },
              buttonsStyling: false
            })
          }
        })
      }
    },
    validationForm () {
      this.$refs.userValidation.validate().then(success => {
        if (success) {
          this.save()
        }
      })
    },
    async getUser () {
      await this.getZones()
      const params = {
        url: `users/${this.uuid}`
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          this.user = data.data.data

          if (!empty(data.data.data.type)) {
            this.validated = 1
            this.selectedType = !empty(this.userType.filter(element => { return element.value === data.data.data.type })) ? this.userType.filter(element => { return element.value === data.data.data.type })[0] : ''
          }

          if (this.user.cfeUsersZones != null) {
            this.user.cfeUsersZones.forEach(element => {
              this.selectedZone.push({
                name: element.cfeZone.name,
                uuid: element.cfeZoneUuid
              })
            })
          }
        }
      })
    }
  },
  created () {
    this.getUser()
  }
}
</script>
